import React from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../ruta-server/BaseApi";

export function AddEditCategoria(props) {
  const { onClose, onRefetch, categoria } = props;
  const { auth } = useAuth();

  const addCategoria = async (data) => {
    try {
      await createCategoriaApi(data, auth.token);
      toast.success("Cartegoría registrada exitosamente");
    } catch (error) {
      throw error;
    }
  };

  const updateCategoria = async (id, data) => {
    try {
      await updateCategoriaApi(id, data, auth.token);
      toast.success("Categoría actualizada exitosamente");
    } catch (error) {
      throw error;
    }
  };

  async function createCategoriaApi(data, token) {
    try {
      const url = `${BASE_API}/api/categoria/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.post(url, data, { headers });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        if (error.response.data.descripcion !== undefined) {
          toast.error("Ya existe esa Categoría");
        }
      }
      throw error;
    }
  }

  async function updateCategoriaApi(id, data, token) {
    try {
      const url = `${BASE_API}/api/categoria/${id}/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.patch(url, data, { headers });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        if (error.response.data.descripcion !== undefined) {
          toast.error("Ya se encuentra registrada la categoría");
        }
      }
      throw error;
    }
  }

  const formik = useFormik({
    initialValues: initialValues(categoria),
    validationSchema: Yup.object(categoria ? updateSquema() : newSchema()),
    validateOnChange: false,
    onSubmit: async (formValue, { resetForm }) => {
      try {
        if (categoria) {
          await updateCategoria(categoria.id_categoria, formValue);
          onRefetch();
          onClose();
        } else {
          await addCategoria(formValue);
          onRefetch();
          resetForm();
        }
      } catch (error) {
        resetForm();
        console.error(error);
      }
    },
  });

  return (
    <>
      <div className="divcampo">
        <label className="campR">
          Campo requerido <span className="astedisco">*</span>
        </label>
      </div>
      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        <label>Categoría</label>
        <Form.Input
          name="descripcion"
          placeholder="Categoría"
          value={formik.values.descripcion}
          onChange={formik.handleChange}
          error={formik.errors.descripcion}
        />
        <Button
          type="submit"
          content={categoria ? "Actualizar" : "Crear"}
          style={{ backgroundColor: "#008e86", color: "white" }}
          fluid
        />
      </Form>
      <ToastContainer />
    </>
  );
}

function initialValues(datosCategoria) {
  return {
    descripcion: datosCategoria?.descripcion || "",
  };
}

function newSchema() {
  return {
    descripcion: Yup.string()
      .required(true)
      .matches(
        /^(?!\d+$)[\w\sáéíóúÁÉÍÓÚñÑ!(),./;:#-]+$/,
        "La descripción debe contener letras y no puede ser solo números"
      ),
  };
}

function updateSquema() {
  return {
    descripcion: Yup.string()
      .required(true)
      .matches(
        /^(?!\d+$)[\w\sáéíóúÁÉÍÓÚñÑ!(),./;:#-]+$/,
        "La descripción debe contener letras y no puede ser solo números"
      ),
  };
}
